import { addSlideFooter } from '../helpers/slide_footer';
import { LINK_COLOR, TITLE_TEXT } from '../helpers/constants';

export const renderMetadataSlide = ({ footer, pptx, slide: model }) => {
  const slide = pptx.addSlide();
  slide.addText(model.title, { ...TITLE_TEXT, fontSize: 14 });

  const text = model.entries.map(({ label, value }) => `${label}: ${value}`).join('\n');
  slide.addText(text, {
    align: 'left',
    color: LINK_COLOR,
    fontFace: 'Arial',
    fontSize: 12,
    h: 3.8,
    lineSpacing: 18,
    valign: 'top',
    w: '90%',
    x: 0.5,
    y: 1.1,
  });

  addSlideFooter({ ...footer, pptx, slide });
  return slide;
};
